import type { IUserRepository, UserUpdateInput } from '../repositories/IUserRepository.js';
import type { UserEntity } from '../entities/UserEntity.js';

export interface UpdateUserInput {
  uid: string;
  input: UserUpdateInput;
}

interface Dependencies {
  userRepository: IUserRepository;
}

export function createUpdateUserUseCase({ userRepository }: Dependencies) {
  return async function updateUser(
    payload: UpdateUserInput,
  ): Promise<UserEntity | null> {
    return userRepository.update(payload.uid, payload.input);
  };
}

